import anime from 'animejs';
import lottie from 'lottie-web';

export default class {
    constructor() {
        this.init();
    }

    init() {
        this.mask = document.querySelector('#js-loading__mask');
        this.first = document.querySelector('#js-loading__mask .js-loading__first');
        this.klc = document.querySelector('#js-loading__klc');
        this.logoElem = document.querySelector('#js-loading__logo');
        this.coverElem = document.querySelector('#js-loading__logo--cover');
        this.btn = document.querySelector('#js-loading__skip');

        if (document.querySelector('#p-campaign')) {
            if (this.mask) {
                this.mask.remove();
            }
            return Promise.resolve();
        }

        if (process.env.MIX_DISP_LOADING == "false" && process.env.NODE_ENV == "development") {
            if (this.mask) {
                this.mask.style.display = "none";
            }
        }

        const keyName = 'visited';
        const keyValue = true;
        this.visited = sessionStorage.getItem(keyName);

        if (!this.visited) {
            sessionStorage.setItem(keyName, keyValue);
            return new Promise(resolve => {
                let skipped = false;

                const skip = document.getElementById("js-loading__skip");
                if (skip) {
                    skip.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (!skipped) {
                            if (this.first) {
                                this.first.style.opacity = '1';
                                this.first.style.display = 'block';
                                this.first.style.transform = 'translateZ(0)';
                            }

                            anime({
                                targets: [this.klc, this.coverElem, this.logoElem, this.first].filter(Boolean),
                                duration: 300,
                                opacity: [1, 0],
                                easing: 'easeOutQuad',
                                complete: () => {
                                    if (this.mask) {
                                        this.mask.remove();
                                    }
                                    resolve();
                                }
                            });

                            skipped = true;
                        }
                    });
                }

                if (this.mask) {
                    this.mask.style.display = "block";
                }

                this.loadingKLC = document.querySelector('#js-loading__klc');

                if (this.loadingKLC) {
                    const klcObj = lottie.loadAnimation({
                        container: this.loadingKLC,
                        renderer: 'svg',
                        loop: true,
                        autoplay: true,
                        path: '/dist/img/main/klc.json'
                    });
                    klcObj.setSpeed(1.5);
                }

                const timeline = anime.timeline();

                if (this.btn) {
                    timeline.add({
                        targets: this.btn,
                        opacity: [0, 1],
                        easing: 'easeOutCubic',
                        duration: 100
                    });
                }

                if (this.loadingKLC) {
                    timeline.add({
                        targets: this.loadingKLC,
                        opacity: [0, 1],
                        easing: 'easeOutQuad',
                        duration: 1000,
                        delay: 400
                    }, '-=100');
                }

                if (this.coverElem) {
                    timeline.add({
                        targets: this.coverElem,
                        translateX: [0, "130%"],
                        easing: 'easeOutSine',
                        duration: 2920
                    }, '-=500');
                }

                if (this.loadingKLC) {
                    timeline.add({
                        targets: this.loadingKLC,
                        opacity: [1, 0],
                        easing: 'easeOutCubic',
                        duration: 400
                    }, '-=2400');
                }

                if (this.logoElem) {
                    timeline.add({
                        targets: this.logoElem,
                        opacity: [1, 0],
                        easing: 'easeOutCubic',
                        duration: 400
                    }, '-=1200');
                }

                if (this.btn) {
                    timeline.add({
                        targets: this.btn,
                        opacity: [1, 0],
                        easing: 'easeOutCubic',
                        duration: 400
                    }, '-=1200');
                }

                if (this.first) {
                    timeline.add({
                        targets: this.first,
                        opacity: [1, 0],
                        easing: 'easeOutCubic',
                        duration: 400,
                        complete: () => {
                            if (this.mask) {
                                this.mask.remove();
                            }
                            resolve();
                        }
                    }, '-=800');
                } else {
                    // 万が一 this.first が無いときはここで resolve
                    resolve();
                }
            });
        } else {
            return new Promise(resolve => {
                if (this.mask) {
                    if (this.btn) this.btn.style.display = "none";
                    this.mask.style.display = "block";
                    if (this.klc) this.klc.style.display = "none";
                    if (this.logoElem) this.logoElem.style.display = "none";
                    if (this.coverElem) this.coverElem.style.display = "none";
                }

                if (this.first) {
                    anime({
                        targets: this.first,
                        opacity: [1, 0],
                        easing: 'easeInOutCubic',
                        duration: 1000,
                        complete: () => {
                            if (this.mask) {
                                this.mask.remove();
                            }
                            resolve();
                        }
                    });
                } else {
                    // this.first が無いときもresolveしとく
                    if (this.mask) {
                        this.mask.remove();
                    }
                    resolve();
                }
            });
        }
    }
}
